import { Box } from '@nimbus-ds/components';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { FEATURE_MAX_USERS } from 'App/features';
import HelpLink from 'App/HelpLink';
import { useNavegate } from 'App/hooks';
import {
  ActionsDesktop,
  HeaderContent,
  HeaderTop,
  IonPageStratus,
  Responsive,
} from 'commons/components';
import { HELP_LINKS_USERS_PERMISSIONS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import getUrlWithParams from 'commons/utils/getUrlWithParams';
import { USERS_CREATE_USER } from 'config/upsellFlowSources';
import { accountRoutes } from 'domains/Account';
import { useUpsellFlow } from 'domains/Billing/UpsellFlow/hooks';
import PartnerAdminAlert from 'domains/Configurations/Notifications/pages/NotificationsListPage/components/PartnerAdminAlert';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import {
  PartnersListDesktop,
  UsersListDesktop,
  UsersListMobile,
  PartnersListMobile,
} from './components';
import { useGetUsersQuantity } from './hooks';

function UsersListPage() {
  const t = useTranslationConfigurations('usersListPage');
  const language = useTranslationLanguage();
  const { goTo } = useNavegate();
  const usersQuantity = useGetUsersQuantity();

  const goToCreateUser = useUpsellFlow({
    title: t('upsellTitle'),
    featureKey: FEATURE_MAX_USERS,
    minValue: usersQuantity + 1,
    trackingSource: USERS_CREATE_USER,
    callback: () =>
      goTo(getUrlWithParams(accountRoutes.userForm, { id: 'new' })),
  });

  const mainAction = {
    appearance: 'primary' as const,
    icon: PlusCircleIcon,
    onClick: goToCreateUser,
    children: t('addUser'),
  };

  const headerTop = <HeaderTop mainAction={mainAction} />;
  const actionsDesktop = <ActionsDesktop actions={[mainAction]} />;

  return (
    <IonPageStratus
      width="large"
      headerTop={headerTop}
      headerContent={
        <HeaderContent title={t('title')} actions={actionsDesktop} />
      }
    >
      <Box display="flex" flexDirection="column" gap="4">
        <PartnerAdminAlert />
        <Responsive
          mobile={<UsersListMobile />}
          desktop={<UsersListDesktop />}
        />
        <Responsive
          mobile={<PartnersListMobile />}
          desktop={<PartnersListDesktop />}
        />
      </Box>
      <HelpLink
        title={t('helpLink.title')}
        previousValue=""
        currentViewTracking={t('helpLink.amplitudeName')}
        linkURL={HELP_LINKS_USERS_PERMISSIONS[language]}
        hasDisclaimer={false}
        icon="both"
      />
    </IonPageStratus>
  );
}

export default UsersListPage;
